// PLUGINS IMPORTS //
import React from "react"
import styled from "styled-components"

// COMPONENTS IMPORTS //
import { memoComparison } from "Content/Shared/Helpers/Functions/Functions"

// EXTRA IMPORTS //
import { iPadResolution } from "Content/Shared/Styles/Theme"

/////////////////////////////////////////////////////////////////////////////

type PropsType = {
  text: string
  icon: string
}

const FieldItem: React.FC<PropsType> = (props) => {
  return (
    <Wrapper>
      <Icon className={props.icon} />
      <div>{props.text}</div>
    </Wrapper>
  )
}

const MARGIN_VERTICAL = "8px"
const Wrapper = styled.div`
  margin-top: ${MARGIN_VERTICAL};
  margin-bottom: ${MARGIN_VERTICAL};
  display: flex;

  @media (max-width: ${iPadResolution}px) {
    div {
      width: 120px;
      text-align: left;
      margin-top: 2px;
    }
  }
`

const Icon = styled.i`
  font-size: 18px;
  margin-right: 16px;
`

export default React.memo(FieldItem, memoComparison)
